// Public runtime config. Set via Vite env at build time.
export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? "https://api-staging.lovd.app",
  zeroUrl: import.meta.env.VITE_ZERO_URL ?? "https://lovd-zero-cache.fly.dev",
};
